export { AmericanNewLanding } from "./AmericanNewLanding";
